import { LocalStorage, getUTCDateInTimezone, customTime } from '@Engage.Core';
class ServerTime {
    constructor() {
        this.localStorage = new LocalStorage();
        this.storageKey = "ServerTimeOffset";
        this.header = "x-server-time";
    }
    setOffset(serverTime) {
        if (serverTime) {
            const offset = this.calculateOffset(serverTime);
            this.localStorage.set(this.storageKey, offset);
        }
    }
    getOffset() {
        return this.localStorage.get(this.storageKey);
    }
    get() {
        const offset = this.getOffset();
        return this.addOffset(offset);
    }
    delete() {
        this.localStorage.delete(this.storageKey);
    }
    calculateOffset(dateLess) {
        const clientTime = getUTCDateInTimezone().valueOf();
        const serverTime = new Date(dateLess).valueOf();
        return clientTime - serverTime;
    }
    addOffset(offset = 0) {
        const clientTime = customTime.get().valueOf();
        return new Date(clientTime + offset);
    }
}
export const serverTime = new ServerTime();
